/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spinner } from 'ui-component-library';

import {
  ModalText,
  ButtonContainer,
  LoadContent,
  LoadingContainer,
  ModalContent,
} from './lock-modal.style';
import LabelValue from '../../card-shared-components/card-label-value/card-label-value';
import lockShape from '../../../../../shapes/lock';
/**
 * Lock Modal Component
 * @param {object} params - object containing props
 * @param {bool} params.showModal - Show modal
 * @param {func} params.closeModal - function to close the modal
 * @param {func}  params.resetTimer- function to reset the timer
 * @param {bool} params.timerExpired - if the timer has expired show timer expired modal
 * @param {object} params.lock - Lock object
 * @param {object} params.loadInfo - Load information related to this lock
 * @return {element}
 */
const LockModal = (
  {
    showModal,
    closeModal,
    resetTimer,
    timerExpired,
    loadInfo,
    lock,
  },
) => (
  <Modal
    isOpen={showModal}
    title={timerExpired ? 'Load Lock Expired' : 'Load Lock Expiring'}
    onModalClose={() => closeModal(false)}
    overflow="wrap"
  >
    <ModalContent>
      {lock?.loading
        && (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        )}
      {!lock?.loading
        && (
          <>
            <ModalText>
              {!timerExpired && `Your lock for this load will expire in 2 minutes.
Any incomplete work will be cleared at that point and you will be sent to the Tracking Queue.
Leaving the load will unlock it, so others can manage it.

If you need to keep the load locked for an additional 10 minutes, you may renew the lock.`}
              {timerExpired && 'Time’s up! You are being sent back to the Tracking Queue. Here is the information of the load you were just managing:'}
              {timerExpired
                && (
                  <LoadContent>
                    <LabelValue label="Load ID#" value={loadInfo.billOfLadingNumber} options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
                    <LabelValue label="Customer" value={loadInfo.customerName} options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
                    <LabelValue label="Carrier" value={loadInfo.carrierName} options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
                    <LabelValue label="Driver Name" value={loadInfo.driverInformation?.driverName} options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
                  </LoadContent>
                )}
            </ModalText>
            <ButtonContainer>
              <Button
                text={timerExpired ? 'Close' : 'Dismiss'}
                isSecondary={!timerExpired}
                size="large"
                onClick={() => closeModal(false)}
              />
              {!timerExpired && (
                <Button
                  text="RENEW LOCK"
                  size="large"
                  onClick={resetTimer}
                />
              )}
            </ButtonContainer>
          </>
        )}
    </ModalContent>
  </Modal>
);

LockModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  timerExpired: PropTypes.bool,
  resetTimer: PropTypes.func,
  loadInfo: PropTypes.object.isRequired,
  lock: lockShape,
};

LockModal.defaultProps = {
  showModal: false,
  closeModal: () => { },
  timerExpired: false,
  resetTimer: () => { },
  lock: {},
};

export default LockModal;
